import {DateRange} from './date-range';
import {FullLengthDateRange} from './full-length-date-range';
import {ImpactDateRange} from './impact-date-range';
import {InsightsTimePickerDateRange} from './insights-time-picker-date-range';
import {UnifiedWithPresetsDateRange} from './unified-with-presets-date-range';
import {PropertyFilterDateRange} from './property-filter-date-range';
import {RelativeDateRange} from './relative-date-range';
import {ExperimentCompletedDateRange, ExperimentDateRange} from './experiment-date-range';
import {DateRangeAttributes, DisplayContext} from './types';
import {UnifiedDateRange} from './unified-date-range';

export const DATE_RANGE_TYPES: {[key in DisplayContext]: typeof DateRange} = {
  [DisplayContext.RelativeRange]: RelativeDateRange,
  [DisplayContext.Default]: DateRange,
  [DisplayContext.FullLength]: FullLengthDateRange,
  [DisplayContext.ImpactTimePicker]: ImpactDateRange,
  [DisplayContext.InsightsTimePicker]: InsightsTimePickerDateRange,
  [DisplayContext.PropertyFilter]: PropertyFilterDateRange,
  [DisplayContext.ExperimentTimePicker]: ExperimentDateRange,
  [DisplayContext.ExperimentCompletedTimePicker]: ExperimentCompletedDateRange,
  [DisplayContext.Unified]: UnifiedDateRange,
  [DisplayContext.UnifiedWithPresets]: UnifiedWithPresetsDateRange,
};

export class DateRangeFactory {
  public static createDateRange(
    attributes: Partial<DateRangeAttributes>,
    {displayContext}: {displayContext: DisplayContext},
  ): DateRange {
    const DateRangeClass = DATE_RANGE_TYPES[displayContext];
    return new DateRangeClass(attributes);
  }
}
